import React, { useEffect } from 'react'

import { SignupProvider } from 'modules/react/signup/SignupContext'
import axios from 'axios'
import { get, set } from 'lodash'

export default function SignupContainer ({ children, employee, course, nonce, restUrls, buttonText, wrapperCls = '', modalRightContent }) {
  const [step, setStep] = React.useState(1)
  const [errors, setErrors] = React.useState({})
  const [selectedCourseDate, setSelectedCourseDate] = React.useState({})
  const [modal, setModal] = React.useState(null)
  const [enterCallback, setEnterCallback] = React.useState()

  const initialFormData = {
    course_id: course.ID,
  }

  const [formData, setFormData] = React.useState(initialFormData)

  useEffect(() => {
    const keyDownHandler = event => {

      if (event.key === 'Enter') {
        event.preventDefault()

        enterCallback()
      }
    }

    document.addEventListener('keydown', keyDownHandler)

    return () => {
      document.removeEventListener('keydown', keyDownHandler)
    }
  }, [enterCallback])

  const contextObject = {
    course: course,
    employee: employee,
    step: step,
    errors: errors,
    restUrls: restUrls,
    buttonText: buttonText,
    useCustomRightContent: modalRightContent?.active,
    modalRightContentStrings: modalRightContent?.active ? modalRightContent.strings : {},
    selectedCourseDate: selectedCourseDate,
    setEnterCallback: setEnterCallback,
    goToStep: (stepToGoTo) => {
      setStep(stepToGoTo)
    },
    goToNextStep: () => {
      setStep(step + 1)
    },
    goBack: () => {
      setStep(step - 1)
    },
    setSelectedCourseDate: setSelectedCourseDate,
    setFormValue: (name, value) => {
      const newFormData = formData

      set(newFormData, name, value)

      setFormData(newFormData)
    },
    getFormValue (name, defaultValue) {
      return get(formData, name, defaultValue)
    },
    submit: (url) => {
      return axios.post(url, {
        ...formData,
      }, {
        headers: {
          'X-WP-Nonce': nonce,
        }
      }).then((response) => {
        console.log(response)
        setErrors({})
        return response
      })
        .then((response) => {
          if (response.data?.location) {
            window.location.href = response.data.location
          }
        })
        .catch((error) => {
          setErrors(error?.response?.data?.errors)
          return Promise.reject(error)
        })
    },
    cleanUp: () => {
      setFormData(initialFormData)
      setErrors({})
      setStep(1)
    },
    modal: modal,
    setModal: (modalRef) => {
      setModal(modalRef)
    }
  }

  return (
    <div className={wrapperCls}>
      <SignupProvider value={contextObject}>
        {children}
      </SignupProvider>
    </div>
  )
}